<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal', 'modal--postgame', determineWinnerCSSClass]" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ isGameWinner ? getTranslations.home_modals_post_game_congratz : getTranslations.home_modals_post_game_too_bad }}
            <br>{{ isGameWinner ? getTranslations.home_modals_post_you_won_the_game : getTranslations.home_modals_post_you_lost_the_game }}</h1>
          <ul>
            <li :class="isHomePlayer?(isGameWinner? 'post_winner':'post_loser') : isGameWinner ?  'post_loser':'post_winner'">
              <img :src="playersDetails.homePlayerAvatar" alt="">
              <span class="name">{{ playersDetails.homePlayerUsername }}</span>
            </li>
            <li class="trophy">
              <img src="static/images/trophy.png" alt="" :class="isGameWinner ? '':'lost_trophy'">
              <div :class="['score', isGameWinner?'post_score_win':'post_score_lost']"><span>{{ homePlayerRoundScore }}</span>-<span>{{ awayPlayerRoundScore }}</span></div>
            </li>
            <li :class="isHomePlayer?(isGameWinner ? 'post_loser':'post_winner'):isGameWinner ? 'post_winner':'post_loser'">
              <img :src="playersDetails.awayPlayerAvatar" alt="">
              <span class="name">{{ playersDetails.awayPlayerUsername }}</span>
            </li>
          </ul>
        </div>
        <div class="modal__body">
          <h3 v-if="isGameWinner && homePlayerRoundScore === awayPlayerRoundScore">
            {{ getTranslations.home_round_ended_you_were_faster }}</h3>
          <h3 v-if="!isGameWinner && homePlayerRoundScore === awayPlayerRoundScore">
            {{ getTranslations.home_round_ended_you_were_slower }}</h3>
          <h3>{{ getTranslations.home_modals_post_game_bonus_points_earned }}</h3>
          <ul class="buttons">
            <li><span class="score-lbl">{{ correctAnswersPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_correct_answers }}</span></li>
            <li><span class="score-lbl" style="background: #aa4225">{{ gameVictoryPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_game_victory }}</span></li>
            <li><span class="score-lbl" style="background: #16a085">{{ totalEarnedPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_total_earned }}</span></li>
          </ul>
          <div class="donut-chart">
            <div class="games-left donut-chart__info info_align" v-if="!userLeveledUp"><span class="num">{{ gameWinsToLevelUp }}</span>{{ getTranslations.home_modals_post_game_games_to_level_up }}</div>
            <div id="level_chart" class="donut-size donut-cont">
              <div class="pie-wrapper">
                <span class="label">
                  <span class="smaller">{{ getTranslations.home_modals_post_game_level }}</span><span class="num">{{ currentLevel }}</span>
                </span>
                <div class="pie">
                  <div class="left-side half-circle"></div>
                  <div class="right-side half-circle"></div>
                </div>
                <div class="shadow"></div>
              </div>
            </div>
            <div class="games-played donut-chart__info" v-if="!userLeveledUp"><span class="num">{{ gamesWon }}</span>{{ getTranslations.home_modals_post_game_games_played }}</div>
          </div>
        </div>

        <div v-if="isAddOnGameEnabled" class="modal__footer add_on_game">
          <h3>
            {{ getTranslations.home_modals_post_game_penalty_description_pt1 }}<br>
            {{ getTranslations.home_modals_post_game_penalty_description_pt2 }}
          </h3>

          <a
            href="#"
            class="btn2 btn2--std btn2--small"
            @click.prevent="$emit('playPenaltyGame')"
          >
            {{ getTranslations.home_modals_post_game_penalty_button_play }}
          </a>
        </div>

        <div v-else class="modal__footer">
          <a @click="checkGameAvailability" class="btn2 btn2--std btn2--small" style="cursor:pointer">{{ getTranslations.home_modals_post_game_new_game }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';
import { pieChartAnimation } from '@/common/jQuery';

export default {
  name: 'post-game',
  data() {
    return {
      correctAnswersPoints: 0,
      roundsVictoryPoints: 0,
      gameVictoryPoints: 0,
      totalEarnedPoints: 0,
      currentLevel: 0,
      gameWinsToLevelUp: 0,
      gamesWon: 0,
    };
  },
  created() {
    console.log('in PostGame created hook:');
    this.correctAnswersPoints = this.isHomePlayer ? this.homePlayerCorrectAnswersPoints : this.awayPlayerCorrectAnswersPoints;
    this.roundsVictoryPoints = this.isHomePlayer ? this.homePlayerRoundVictoriesPoints : this.awayPlayerRoundVictoriesPoints;
    this.gameVictoryPoints = this.isHomePlayer ? this.homePlayerGameVictoryPoints : this.awayPlayerGameVictoryPoints;
    this.totalEarnedPoints = this.isHomePlayer ? this.homePlayerTotalEarnedPoints : this.awayPlayerTotalEarnedPoints;
    this.currentLevel = this.isHomePlayer ? this.homePlayerCurrentLevel : this.awayPlayerCurrentLevel;
    this.gameWinsToLevelUp = this.isHomePlayer ? this.homePlayerGameWinsToLevelUp : this.awayPlayerGameWinsToLevelUp;
    this.gamesWon = this.isHomePlayer ? this.homePlayerGamesWon : this.awayPlayerGamesWon;
  },
  mounted() {
    setTimeout(() => {
      pieChartAnimation('#level_chart', this.getGamesWonRatio());
    }, 100);
  },
  beforeDestroy() {
    this.resetPlayersAnswersHistoryCSSClasses();
  },
  methods: {
    ...mapMutations('game', [
      'resetPlayersAnswersHistoryCSSClasses',
    ]),
    checkGameAvailability() {
      console.log('inside checkGameAvailability method');
      console.log('getUserAvailableGames:', this.getUserAvailableGames);
      if (this.getUserAvailableGames === 0) {
        sessionStorage.removeItem('zeroBalancePopUp');
        console.log('going back to home page');
        this.$router.push('/home');
      } else {
        console.log('emitting updateNormalTransitionAndStartNewGame event');
        this.$emit('updateNormalTransitionAndStartNewGame');
      }
    },
    getGamesWonRatio() {
      return this.userLeveledUp ? 100 : ((this.gamesWon / (this.gameWinsToLevelUp + this.gamesWon)) * 100).toFixed(2);
    },
  },
  computed: {
    ...mapState('game', [
      'playersDetails',
      'homePlayerRoundScore',
      'homePlayerCorrectAnswersPoints',
      'homePlayerRoundVictoriesPoints',
      'homePlayerGameVictoryPoints',
      'homePlayerTotalEarnedPoints',
      'homePlayerCurrentLevel',
      'homePlayerGameWinsToLevelUp',
      'homePlayerGamesWon',
      'awayPlayerRoundScore',
      'awayPlayerCorrectAnswersPoints',
      'awayPlayerRoundVictoriesPoints',
      'awayPlayerGameVictoryPoints',
      'awayPlayerTotalEarnedPoints',
      'awayPlayerCurrentLevel',
      'awayPlayerGameWinsToLevelUp',
      'awayPlayerGamesWon',
      'userLeveledUp',
    ]),
    ...mapGetters('common', [
      'getUserAvailableGames',
      'isAddOnGameEnabled',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    determineWinnerCSSClass() {
      return (this.isHomePlayer && this.isGameWinner) || (!this.isHomePlayer && !this.isGameWinner) ? 'player1' : 'player2';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PostGame.vue